import { render, staticRenderFns } from "./FreeAttributesForm.vue?vue&type=template&id=7fee109c&scoped=true&"
import script from "./FreeAttributesForm.vue?vue&type=script&lang=js&"
export * from "./FreeAttributesForm.vue?vue&type=script&lang=js&"
import style0 from "./FreeAttributesForm.vue?vue&type=style&index=0&id=7fee109c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fee109c",
  null
  
)

export default component.exports